import $ from 'jquery';
import { debounce } from 'Util/debounce';

const selectors = Object.freeze({
	select: '.js-select-link'
});

const module = {
	init: function () {
		module._initEvents();
	},

	_initEvents: function () {
		$(selectors.select).on('change', module._changeEvent);
	},

	_changeEvent: function (e) {
		const $select = $(e.target);

		module._change($select);
	},

	_change: debounce(function ($select) {
		const value = $select.val();

		document.location = value;
	}, 500)
};

const selectLink = {
	init: module.init
};

export { selectLink };
